import { Component, HostBinding, Input, EventEmitter, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-horizontal-scale-slider',
  templateUrl: './horizontal-scale-slider.component.html',
  styleUrl: './horizontal-scale-slider.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HorizontalScaleSliderComponent),
      multi: true,
    },
  ],
})
export class HorizontalScaleSliderComponent   implements ControlValueAccessor
{
  private untouchedColor = '#AAAAAA';
  private _isTouched = false;

  public get isTouched() : boolean {
    return this._isTouched;
  }


  /** track & handle color */
  @Input() baseColor = '#5c6bc0';
  /** low‐alpha track */
  @HostBinding('style.--track-color')
  get trackColor() {
    const hex = this.baseColor.replace('#', '');
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    return `rgba(${r},${g},${b},0.2)`;
  }
  @HostBinding('style.--curr-color') get currColor() {
    if (!this.isTouched) {
      return this.untouchedColor;
    }
    else{
      return this.baseColor;
    }
  }

  /** values from 1 to 10 */
  ticks = Array.from({ length: 10 }, (_, i) => i + 1);

  private _value = 5;
  @Input()
  get value() {
    return this._value;
  }
  set value(v: number) {
    const capped = Math.min(10, Math.max(1, Math.round(v)));
    if (capped !== this._value) {
      this._value = capped;
      this.onChange(this._value);
      this.valueChange.emit(this._value);
    }
  }
  @Output() valueChange = new EventEmitter<number>();

  // CVA interface
  onChange = (v: number) => {
    this._isTouched = true;
  };

  onTouched = () => {
    this._isTouched = true;
  };
  writeValue(v: number) {
    if (v != null) this._value = Math.min(10, Math.max(1, Math.round(v)));
  }
  registerOnChange(fn: any) {
    this.onChange = fn;
  }
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  /** click to jump */
  onTrackClick(e: MouseEvent) {
    const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const ratio = clickX / rect.width;
    this.value = 1 + ratio * 9;
    this.onTouched();
  }
}
